// helpers/objectEquals.js
export const objectEquals = (prev, next) => {
    if (prev === next) return prev;
    if (!prev || !next) return next;

    const keysA = Object.keys(prev);
    const keysB = Object.keys(next);
    if (keysA.length !== keysB.length) return next;

    for (let i = 0; i < keysA.length; i++) {
        const k = keysA[i];
        const va = prev[k];
        const vb = next[k];

        if (Array.isArray(va) && Array.isArray(vb)) {
            if (va.length !== vb.length) return next;
            for (let j = 0; j < va.length; j++) {
                // si tus items tienen id, aquí puedes optimizar comparando solo id
                if (JSON.stringify(va[j]) !== JSON.stringify(vb[j]))
                    return next;
            }
        } else if (va !== vb) {
            return next;
        }
    }

    return prev; // todo igual → conserva referencia
};
